import {validAccountNoRegex} from '@/services/validators.service'
import {bookkeepingAccounts} from '@/bookkeeping-account/bookkeepingAccount.service'
import {Maybe} from '@/types/Maybe'

export const validateAccountNo = (accountNo: Maybe<string>): string | undefined => {
    if (!accountNo || accountNo?.trim().length === 0) {
        return 'bookkeeping-account.validation.account-no.blank'
    }
    if(!!accountNo && !validAccountNoRegex.test(accountNo)) {
        return 'bookkeeping-account.validation.account-no.invalid'
    }
    if (!!accountNo && +accountNo >= 2700 && +accountNo <= 2740) {
        return 'bookkeeping-account.validation.account-no.invalid'
    }
}

export const validateBookkeepingAccountNo = (accountNo: Maybe<string>): string | undefined => {
    if (validateAccountNo(accountNo)) {
       return validateAccountNo(accountNo)
    }
    if (bookkeepingAccounts.value.some((acc) => acc.accountNo === accountNo)) {
        return 'bookkeeping-account.validation.account-no.exists'
    }
}

export const validateName = (name: Maybe<string>): string | undefined => {
    if (!name || name?.trim().length === 0) {
        return 'bookeeping-account.validation.name.blank'
    }
}

export const accountNoInputValidation = () => {
    const customInput = document.getElementById('customInput')
    const maxLength = 4
    const startsWithZeroRegex: RegExp = /^0/
    if (customInput) {
        customInput.addEventListener('input', (event: any) => {
            if (event.target.value.length > maxLength || startsWithZeroRegex.test(event.target.value)) {
                event.target.value = event.target.value.slice(0, -1)
            }
        })
    }
}